var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowers03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#faf4ed;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-1",
    d: "M50.71,187.86l5.56-3.62a120.61,120.61,0,0,1,166.84,35.44h0l-5.56,3.61A120.61,120.61,0,0,1,50.71,187.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-1",
    d: "M242.47,63.29,248,59.67h0A120.61,120.61,0,0,1,212.6,226.51L207,230.12h0A120.61,120.61,0,0,1,242.47,63.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14-2",
    "data-name": "Rectangle 14-2",
    className: "cls-1",
    d: "M202.21,199.7l5.57-3.62h0a120.62,120.62,0,0,1-35.44,166.84l-5.57,3.61h0A120.61,120.61,0,0,1,202.21,199.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15-2",
    className: "cls-1",
    d: "M191.71,206.53l5.56-3.62a120.61,120.61,0,0,1,166.84,35.44h0L358.54,242a120.59,120.59,0,0,1-166.83-35.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowers03);
export default __webpack_public_path__ + "static/media/flowers-03.5e3647386670b105023ef95fe0fa57f7.svg";
export { ForwardRef as ReactComponent };